import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/boosted-apy.png';
import _imports_1 from '@/assets/images/svg/boost-text.svg';
import _imports_2 from '@/assets/images/coin.png';
const _withScopeId = n => (_pushScopeId("data-v-2cdc0d4d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "px-5 text-white bg-[#1f333b] rounded-small md:min-h-[126px] strategy"
};
const _hoisted_2 = { class: "flex flex-wrap justify-between items-center py-2.5 border-b border-light-blue/20 border-solid" };
const _hoisted_3 = { class: "leading-none md:min-w-[144px] title-italic" };
const _hoisted_4 = { class: "text-[1.25rem] md:text-h3" };
const _hoisted_5 = { class: "flex items-center ml-1.5" };
const _hoisted_6 = {
    key: 0,
    src: _imports_0,
    class: "mt-0.5 mr-1 h-[20px] md:h-[26px]",
    alt: "boosted apy"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    class: "md:h-[18px]",
    alt: "boosted text"
}, null, -1));
const _hoisted_8 = {
    key: 1,
    class: "mx-4 w-[1px] h-[30px] bg-light-blue/20"
};
const _hoisted_9 = ["disabled"];
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { class: "flex flex-col pt-1 pb-1.5 md:flex-row md:flex-wrap md:pb-0.5" };
const _hoisted_12 = { class: "grid grid-cols-2 py-2 md:mr-9" };
const _hoisted_13 = { class: "flex md:w-[105px]" };
const _hoisted_14 = { class: "inline-block md:block" };
const _hoisted_15 = { class: "flex items-center mb-0.5" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-[0.6875rem] leading-9/10 text-light-blue title" }, "tvl", -1));
const _hoisted_17 = { class: "flex justify-center items-center ml-1 w-2.5 h-2.5 text-[0.5rem] font-bold text-light-blue rounded-full border border-light-blue opacity-50" };
const _hoisted_18 = /*#__PURE__*/ _createTextVNode(" i ");
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = {
    key: 0,
    class: "text-[1.625rem] leading-10/10 title-italic"
};
const _hoisted_21 = {
    key: 0,
    class: "text-h4"
};
const _hoisted_22 = {
    key: 1,
    class: "text-h4"
};
const _hoisted_23 = { class: "flex md:w-[105px]" };
const _hoisted_24 = { class: "inline-block md:block" };
const _hoisted_25 = { class: "flex items-center mb-0.5" };
const _hoisted_26 = { class: "text-[0.6875rem] leading-9/10 text-light-blue title" };
const _hoisted_27 = { class: "flex justify-center items-center ml-1 w-2.5 h-2.5 text-[0.5rem] font-bold text-light-blue rounded-full border border-light-blue opacity-50" };
const _hoisted_28 = /*#__PURE__*/ _createTextVNode(" i ");
const _hoisted_29 = [
    _hoisted_28
];
const _hoisted_30 = {
    key: 0,
    class: "flex text-[1.625rem] leading-10/10 title-italic"
};
const _hoisted_31 = {
    key: 0,
    src: _imports_0,
    class: "mt-0.5 mr-1 h-[26px]",
    alt: "boosted apy"
};
const _hoisted_32 = { class: "grid grid-cols-2 md:flex md:flex-wrap md:grow md:grid-cols-none" };
const _hoisted_33 = { class: "py-2 pr-4 md:pr-6 md:min-w-[145px]" };
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "flex items-center mb-0.5" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "text-[0.6875rem] leading-9/10 text-light-blue title" }, "Deposited")
], -1));
const _hoisted_35 = { class: "text-[1.625rem] leading-10/10 break-all title-italic" };
const _hoisted_36 = { class: "flex py-2" };
const _hoisted_37 = { class: "flex items-center mb-0.5" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-[0.6875rem] leading-9/10 text-light-blue title" }, "Earned BLID", -1));
const _hoisted_39 = {
    key: 0,
    class: "flex justify-center items-center ml-1 w-2.5 h-2.5 text-[0.5rem] font-bold text-light-blue rounded-full border border-light-blue opacity-50"
};
const _hoisted_40 = /*#__PURE__*/ _createTextVNode(" i ");
const _hoisted_41 = [
    _hoisted_40
];
const _hoisted_42 = { class: "flex flex-wrap items-center title-italic" };
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_2,
    class: "mr-1.5 -mb-[5px] h-[25px]",
    alt: "bolideCoin"
}, null, -1));
const _hoisted_44 = { class: "text-[1.625rem] leading-10/10 text-light-yellow break-all" };
const _hoisted_45 = {
    key: 0,
    class: "self-end pb-0.5 pl-1.5 leading-none text-green break-all"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SpinnerMini = _resolveComponent("SpinnerMini");
    const _directive_tippy = _resolveDirective("tippy");
    return (_ctx.strategy)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.strategy.title), 1),
                    _createElementVNode("div", {
                        class: _normalizeClass(["text-xs md:text-sm", _ctx.vaultNameColor])
                    }, _toDisplayString(_ctx.vaultName), 3)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    (_ctx.showBoostBtn)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('boost'))),
                            class: "flex items-center text-h4 tracking-tight leading-10/10 bg-clip-text bg-boost-text active:scale-90 md:text-h3 title-italic text-fill"
                        }, [
                            (_ctx.strategy.dataLoaded.userBoosting &&
                                _ctx.strategy.formatted.userBoosting &&
                                _ctx.strategy.formatted.userBoosting.apy === '0')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                                : _createCommentVNode("", true),
                            _hoisted_7
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.showBoostBtn)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                        : _createCommentVNode("", true),
                    _createElementVNode("button", {
                        class: "flex justify-center items-center w-[58px] h-[30px] text-h4 tracking-tight leading-10/10 text-green md:w-[78px] md:text-h3 title-italic btn-manage",
                        disabled: _ctx.strategy.isBtnProgress,
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('open')))
                    }, [
                        (_ctx.strategy.isBtnProgress)
                            ? (_openBlock(), _createBlock(_component_SpinnerMini, { key: 0 }))
                            : (_openBlock(), _createElementBlock("span", _hoisted_10, "Manage"))
                    ], 8, _hoisted_9)
                ])
            ]),
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19)), [
                                    [_directive_tippy, _ctx.tippy.TVLDesktop]
                                ])
                            ]),
                            (_ctx.strategy.dataLoaded.tvl)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    (_ctx.strategy.formatted.tvl.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("span", null, "$" + _toDisplayString(_ctx.strategy.formatted.tvl.separately.firstNum), 1),
                                            (_ctx.strategy.formatted.tvl.separately.secondNum)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "." + _toDisplayString(_ctx.strategy.formatted.tvl.separately.secondNum), 1))
                                                : _createCommentVNode("", true),
                                            (_ctx.strategy.formatted.tvl.symbol)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.strategy.formatted.tvl.symbol), 1))
                                                : _createCommentVNode("", true)
                                        ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode("$" + _toDisplayString(_ctx.strategy.formatted.tvl), 1)
                                        ], 64))
                                ]))
                                : (_openBlock(), _createBlock(_component_SpinnerMini, {
                                    key: 1,
                                    class: "mt-1.5 w-6 h-6"
                                }))
                        ])), [
                            [_directive_tippy, _ctx.tippy.TVLMobile]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.isBoosting ? 'boosted apy' : 'apy'), 1),
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29)), [
                                    [_directive_tippy, _ctx.tippy.APYDesktop]
                                ])
                            ]),
                            (_ctx.strategy.dataLoaded.apy)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    (_ctx.isBoosting)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.strategy.dataLoaded.userBoosting &&
                                        _ctx.strategy.formatted.userBoosting &&
                                        _ctx.strategy.formatted.userBoosting.apy !== '0'
                                        ? _ctx.strategy.formatted.userBoosting.apy
                                        : _ctx.strategy.formatted.apy) + "%", 1)
                                ]))
                                : (_openBlock(), _createBlock(_component_SpinnerMini, {
                                    key: 1,
                                    class: "mt-1.5 w-6 h-6"
                                }))
                        ])), [
                            [_directive_tippy, _ctx.tippy.APYMobile]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, " $" + _toDisplayString(_ctx.strategy.deposit.depositAmountInUSD), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                            _createElementVNode("div", _hoisted_37, [
                                _hoisted_38,
                                (_ctx.isStorageContract)
                                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41)), [
                                        [_directive_tippy, _ctx.tippy.earnedIncomeDesktop]
                                    ])
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.strategy.deposit.earnedBLID), 1),
                                (_ctx.strategy.deposit.earnedUSD !== '0')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, "$" + _toDisplayString(_ctx.strategy.deposit.earnedUSD), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ])), [
                            [_directive_tippy, _ctx.isStorageContract ? _ctx.tippy.earnedIncomeMobile : undefined]
                        ])
                    ])
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
